import React, { useEffect, useState } from "react";
import { fetchFeedData } from "./MemberProfileFetchData.js";
import "../../Styles/MemberProfileFeedData.css";
import ShareButton from "../../../../common/Actions/shareButton.js";
import LikeButton from "../../../../common/Actions/likeButton.js";
import SuggestButton from "../../../../common/Actions/suggestButton.js";
import Carousel from "../../../../common/Carousel/Carousel";
import GridLayout from "../../../../common/Grid/gridMode";
import LightboxGallery from "../../../../common/LightBox/lightBox";
import HorizontalScrollDisplay from "../../../../common/HorizontalScroll/horizontalScroll";
import VerticalScroll from "../../../../common/VerticalScroll/verticalScroll";

const MPFeedContent = ({ userId, mediaDisplayMode }) => {
  const [feedData, setFeedData] = useState({ feeds: [] });
  const [connectionStatus, setConnectionStatus] = useState("not_connected"); 

  useEffect(() => {
    const loadFeedData = async () => {
      const data = await fetchFeedData();
      setFeedData(data);

      // initialize connection status (at user level, not post level)
      setConnectionStatus(data?.status || "not_connected");
    };
    loadFeedData();
  }, []);

  // ---- Handlers ----
  const handleSendRequest = () => {
    setConnectionStatus("pending");
    console.log(`Connection request sent for user: ${userId}`);
    // API call → send connection request
  };

  const handleCancelRequest = () => {
    setConnectionStatus("not_connected");
    console.log(`Connection request canceled for user: ${userId}`);
    // API call → cancel request
  };

  const handleDisconnect = () => {
    setConnectionStatus("not_connected");
    console.log(`Disconnected from user: ${userId}`);
    // API call → disconnect
  };

  const handleBlockUser = () => {
    setConnectionStatus("blocked");
    // API call → block user
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        marginLeft: -20,
        marginTop: -10,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="mp-feed-container" style={{marginTop: 20}}>
        {Array.isArray(feedData?.feeds) &&
          feedData.feeds.map((post) => (
            <div key={post.postId} className="mp-post-card">
              {/* User Header */}
              <div className="mp-user-container">
                <div>
                  <p className="text-header" style={{ marginLeft: 10, marginTop: 20 }}>
                    {post.postId}
                  </p>
                </div>
                <div>
                  <p className="text-label" style={{ marginLeft: 10 }}>
                    {post.location}, {new Date(post.timestamp).toLocaleString()}
                  </p>
                </div>
                <div>
                  <p className="text-label" style={{ marginLeft: 10, marginTop: 0 }}>
                    {post.descriptions}
                  </p>
                </div>
              </div>

              {/* Post Media */}
              <div className="mp-feed-media" style={{ marginTop: 0 }}>
                {Array.isArray(post.medias) && post.medias.length > 0 && (
                  <>
                    {mediaDisplayMode === "slideshow" ? (
                      <Carousel items={post.medias.map((m) => m.mediaurl)} />
                    ) : mediaDisplayMode === "lightbox" ? (
                      <LightboxGallery mediaFiles={post.medias.map((m) => m.mediaurl)} />
                    ) : mediaDisplayMode === "horizontal-scroll" ? (
                      <HorizontalScrollDisplay medias={post.medias} />
                    ) : mediaDisplayMode === "vertical-scroll" ? (
                      <VerticalScroll medias={post.medias} />
                    ) : (
                      <GridLayout mediaFiles={post.medias} />
                    )}
                  </>
                )}
              </div>

              {/* Post Actions */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <div
                  className="mp-post-stats-left"
                  style={{ display: "flex", flexDirection: "row", gap: 30, fontSize: 14 }}
                >
                  <LikeButton count={post.nlikes} style={{ fontSize: 14 }} />
                  <ShareButton count={post.nshares} />
                  <SuggestButton />
                </div>
                <div className="mp-post-stats-right">
                  <span
                    className="text-label"
                    style={{
                      fontSize: 18,
                      marginRight: 10,
                      color: "white",
                      fontWeight: "normal",
                    }}
                  >
                    👀 {post.impressions || 0} Impressions
                  </span>
                </div>
              </div>
            </div>
          ))}
      </div>

      {/* <div style={{ marginTop: 20, display: "flex", gap: "10px" }}>
        {connectionStatus === "not_connected" && (
          <button onClick={handleSendRequest}>Request Connection</button>
        )}

        {connectionStatus === "pending" && (
          <>
            <button disabled>Request Sent</button>
            <button onClick={handleCancelRequest}>Cancel Request</button>
          </>
        )}

        {connectionStatus === "connected" && (
          <>
            <button disabled>Connected</button>
            <button onClick={handleDisconnect}>Disconnect</button>
          </>
        )}

        {connectionStatus !== "blocked" && (
          <button onClick={handleBlockUser}>Block User</button>
        )}

        {connectionStatus === "blocked" && (
          <span style={{ color: "red", marginLeft: 10 }}>User Blocked</span>
        )}
      </div> */}
    </div>
  );
};

export default MPFeedContent;
